import { Container, Texture } from '../../../odie';

import { FireboxBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const countAssets = [
  'firebox/block.firebox.0.png',
  'firebox/block.firebox.1.png',
  'firebox/block.firebox.2.png',
];

/*
    firebox block view
*/
export class FireboxBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  // state
  private _sprite: FitWidthBlockSprite;
  private _count = 0;

  // properties
  //-------------------------------------------------------------------------
  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    // update field
    this._count = value;

    // update view texture based on count
    this._sprite.texture = Texture.from(countAssets[value]);
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: FireboxBlockProps) {
    // spawn
    super();
    this._sprite = new FitWidthBlockSprite(countAssets[0], props);
    this.addChild(this._sprite);

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [...countAssets];
  }
}
